if (!customElements.get('fp-service-bar')) {
    customElements.define('fp-service-bar', class extends HTMLElement {
      connectedCallback() {
        if (this.serviceBarReady) return;
        this.serviceBarReady = true;
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.addEventListener('click', (event) => {
          if (event.target.closest('.fp-servicebar__close')) this.closePanel();
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.details.open) {
            event.preventDefault();
            this.closePanel();
          }
        });
        this.classList.add('is-enhanced');
      }
      closePanel() {
        this.details.open = false;
        this.summary.focus();
      }
    });
  }
